import { FlexBox, Icon } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';

import { useConversationRow } from 'app/views/layout/views/conversations/components/table/components/rows/conversationRow/utils/useConversationRow';

import { ConversationsTablePreviewButton } from './components/previewButton/conversationsTablePreviewButton';
import { ConversationsTableRowMenu } from './components/rowMenu/conversationsTableRowMenu';
import styles from './conversationsTableActions.module.scss';

/** Represents the content of the actions cell in the conversations table. */
export const ConversationsTableActions = (): JSX.Element => {
  const { isRestricted } = useConversationRow();

  return (
    <FlexBox
      className={styles.container}
      alignItems="center"
      justifyContent="space-around"
    >
      {isRestricted ? (
        <>
          <Icon name="eye-slash" color={colors.neutral['400']} />
          <Icon name="dots-v" color={colors.neutral['400']} />
        </>
      ) : (
        <>
          <ConversationsTablePreviewButton />
          <ConversationsTableRowMenu />
        </>
      )}
    </FlexBox>
  );
};
